import * as React from "react";

function SvgArrowRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.586 9H2V7h8.586L7.293 3.707l1.414-1.414L14.414 8l-5.707 5.707-1.414-1.414L10.586 9z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgArrowRight;
